<p-dialog [header]="'Actualizar Token Delegado SIAT'" [(visible)]="profileService.showModalToken"
  [modal]="true" [breakpoints]="{ '960px': '70vw', '576px': '95%' }" [style]="{ width: '520px' }" [draggable]="false"
  [resizable]="false" (onHide)="onHide()" [dismissableMask]="true">

  <div class="refresh-token-modal-content">
    <app-alert-notify></app-alert-notify>

    <!-- Info Banner -->
    <div class="siat-info-banner d-flex align-items-start gap-2.5 p-2.5 mb-3 rounded-3">
      <i class="fas fa-shield-halved text-warning font-size-18 mt-0.5 flex-shrink-0"></i>
      <div class="font-size-12 lh-base text-muted">
        Ingrese el <strong>Token Delegado de Facturación</strong> obtenido desde el portal del Servicio de Impuestos Nacionales (SIAT) junto con su período oficial de vigencia.
      </div>
    </div>

    <form [formGroup]="tokenForm" (ngSubmit)="resfreshTokenSiat()">
      <!-- Token Delegado SIAT -->
      <div class="mb-3">
        <label class="font-semibold font-size-12 block mb-1">
          Token Delegado SIAT <span class="text-danger">*</span>
        </label>
        <textarea class="form-control font-monospace font-size-12 token-textarea" rows="4"
          formControlName="siatToken"
          placeholder="Pegue aquí el Token JWT completo provisto por el SIN..."
          [class.is-invalid]="validatorsService.inputValid('siatToken', tokenForm)"></textarea>
        @if (validatorsService.inputValid('siatToken', tokenForm)) {
          <small class="p-error block mt-1 font-size-11">
            {{ validatorsService.inputValidMessage("siatToken", tokenForm) }}
          </small>
        }
      </div>

      <!-- Fechas de Vigencia -->
      <div class="row g-2.5 mb-2">
        <!-- Fecha de Inicio -->
        <div class="col-12 col-sm-6">
          <label class="font-semibold font-size-12 block mb-1">
            Fecha de Inicio <span class="text-danger">*</span>
          </label>
          <p-datepicker formControlName="tokenInitDate" appendTo="body" dateFormat="dd/mm/yy" placeholder="dd/mm/aaaa"
            [iconDisplay]="'input'" styleClass="w-100" [inputStyle]="{ width: '100%' }"
            [class.ng-dirty]="validatorsService.inputValid('tokenInitDate', tokenForm)">
          </p-datepicker>
          @if (validatorsService.inputValid('tokenInitDate', tokenForm)) {
            <small class="p-error block mt-1 font-size-11">
              {{ validatorsService.inputValidMessage("tokenInitDate", tokenForm) }}
            </small>
          }
        </div>

        <!-- Fecha de Expiración -->
        <div class="col-12 col-sm-6">
          <label class="font-semibold font-size-12 block mb-1">
            Fecha de Expiración <span class="text-danger">*</span>
          </label>
          <p-datepicker formControlName="tokenEndDate" appendTo="body" dateFormat="dd/mm/yy" placeholder="dd/mm/aaaa"
            [iconDisplay]="'input'" styleClass="w-100" [inputStyle]="{ width: '100%' }"
            [minDate]="minEndDate() || undefined"
            [class.ng-dirty]="validatorsService.inputValid('tokenEndDate', tokenForm)">
          </p-datepicker>
          @if (validatorsService.inputValid('tokenEndDate', tokenForm)) {
            <small class="p-error block mt-1 font-size-11">
              {{ validatorsService.inputValidMessage("tokenEndDate", tokenForm) }}
            </small>
          }
        </div>

        <!-- Validación de rango de fechas -->
        @if (tokenForm.errors?.['invalidDateRange'] && tokenForm.get('tokenEndDate')?.touched) {
          <div class="col-12">
            <small class="p-error block font-size-11">
              <i class="fas fa-circle-exclamation me-1"></i> La fecha de expiración debe ser posterior a la fecha de inicio.
            </small>
          </div>
        }
      </div>
    </form>
  </div>

  <ng-template pTemplate="footer">
    <div class="d-flex align-items-center justify-content-end gap-2 w-100">
      <p-button (click)="profileService.showModalToken = false" label="Cancelar"
        styleClass="p-button-outlined p-button-secondary p-button-sm p-button-rounded"></p-button>
      <p-button (click)="resfreshTokenSiat()" styleClass="p-button-sm p-button-rounded p-button-primary"
        label="Guardar Token" icon="fas fa-floppy-disk" [loading]="loading()"
        [disabled]="loading() || tokenForm.invalid"></p-button>
    </div>
  </ng-template>
</p-dialog>
